module.exports = __webpack_public_path__ + "Logo (Sin nombre).png?36dce2c9dc38d46b1bde77d5f230fbeb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo (Sin nombre).png
// module id = 1199
// module chunks = 0